// extracted by mini-css-extract-plugin
export var close = "Galeria-module--close--T5pJ-";
export var grid__overlay = "Galeria-module--grid__overlay--RbE1s";
export var grid__title = "Galeria-module--grid__title--2BJVj";
export var open = "Galeria-module--open--gX8YF";
export var overlay = "Galeria-module--overlay--gTDdK";
export var overlay__inner = "Galeria-module--overlay__inner--AkIO3";
export var portfolio = "Galeria-module--portfolio--ZcDiD";
export var project = "Galeria-module--project--feQ60";
export var project__image = "Galeria-module--project__image--QZEtw";